module.exports = __webpack_public_path__ + "img/wb_ic_star.f186b7be.svg";